import type { ArenaState } from "@shared/types";

interface ScoreBarProps {
  state: ArenaState;
}

export function ScoreBar({ state }: ScoreBarProps) {
  const { dawn, dusk } = state.score;
  const total = Math.max(1, dawn + dusk);
  const dawnPct = (dawn / total) * 100;

  const remaining = Math.max(0, state.matchEndsAt - Date.now());
  const mins = Math.floor(remaining / 60000);
  const secs = Math.floor((remaining % 60000) / 1000);

  return (
    <div className="pointer-events-none absolute left-1/2 top-4 w-[28rem] -translate-x-1/2">
      <div className="mb-1 flex items-center justify-between text-xs font-medium">
        <span className="text-dawn-400">☀️ Dawn {dawn}</span>
        <span className="rounded bg-archer-900/80 px-2 py-0.5 font-mono text-white">
          {mins}:{secs.toString().padStart(2, "0")}
        </span>
        <span className="text-dusk-400">{dusk} Dusk 🌙</span>
      </div>
      <div className="flex h-2 overflow-hidden rounded-full border border-archer-700">
        <div
          className="h-full bg-gradient-to-r from-dawn-600 to-dawn-400 transition-all duration-500"
          style={{ width: `${dawnPct}%` }}
        />
        <div
          className="h-full flex-1 bg-gradient-to-r from-dusk-400 to-dusk-600 transition-all duration-500"
        />
      </div>
    </div>
  );
}
